module.exports = __webpack_public_path__ + "img/12.279e7e08.jpg";